// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

import Amplify, { Auth, Logger } from 'aws-amplify'
import awsexports from './aws-exports'

Vue.config.productionTip = false

Amplify.configure(awsexports)
// Amplify.Logger.LOG_LEVEL = 'DEBUG'
Amplify.Logger.LOG_LEVEL = 'INFO'

const logger = new Logger('main')

Auth.currentUserInfo()
  .then(user => logger.debug(user))
  .catch(err => logger.debug(err))

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js